import { Box, Grid, Icon, IconButton, TextField } from '@mui/material';
import CustomToolTips from 'components/CustomToolTips';
import CardTotalizador, { CardTotalizadorLabel, CardTotalizadorValue } from 'components/cards/CardTotalizador';
import FloatingActions, { FloatingActionsProps } from 'components/floatingactions/FloatingActions';
import { CustomButton } from 'components/roundedbutton/CustomButton';
import { getFormaPagamentoAbstracModel } from 'components/telaformaspagamento/TelaFormasPagamentoComponent';
import useCatchApiError from 'hooks/useCatchApiError';
import { useGenerateUuid } from 'hooks/useGenerateUuid';
import { useSnackbarCustom } from 'hooks/useSnackCustom';
import { IToken } from 'model/token.model';
import AutorizaDescontoAcrescimo from 'pages/Configuracoes/AutorizaDescontoAcrescimo';
import AutorizaDescontoItemError from 'pages/Configuracoes/AutorizaDescontoItemError';
import { ConfiguracaoDescontoTO, TipoDescontoAcrescimoAutorizador } from 'pages/Configuracoes/Configuracoes.model';
import ConfiguracaoDescontoAcrescimoService from 'pages/Configuracoes/configuracao-desconto-acrescimo.service';
import useFlowRoles from 'hooks/useFlowRoles';
import DadosTransportador from 'pages/DadosTransportador';
import CustomLoading from 'pages/Venda/Header/CustomLoading';
import LoginService from 'pages/login/login.service';
import TrocaReferenciadaDialog from 'pages/nota-referenciada/TrocaReferenciadaDialog';
import { TipoInformacaoAdicional } from 'pages/pagamento/pagamento.model';
import PagamentoService from 'pages/pagamento/pagamento.service';
import DescontoInput from 'pages/registra-venda/DescontoInput';
import PreVendaPdf, { PreVendaState } from 'pages/registra-venda/PreVendaPdf';
import RegistraVendaService from 'pages/registra-venda/registra-venda.service';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { SourceType } from 'react-number-format/types/types';
import { useLocation } from 'react-router-dom';
import { changeLinearFinalizaVenda, loadingWithOpt, Tipo } from 'redux/features/blockuiSlice';
import { setConfiguracaoDescontoAutorizador } from 'redux/features/configuracoes';
import { resetDesconto } from 'redux/features/descontoFixoSlice';
import { resetChavesReferenciadas } from 'redux/features/notaReferenciadaSlice';
import { addRow, changeTotalLiquido, resetPagamento, resetRows, setvalorDescontoPagamento } from 'redux/features/pagamentoSlice';
import { addPedidoDescontoAcrescimo, resetAcrescimoFooter, resetDescontoFooter, resetState, setAcrescimo, setDescontoFooter, setTransportador, setValorLiquido, toogleTipoDescontFooter } from 'redux/features/stateSlice';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { customColors, theme } from 'theme';
import useCustomLocation from 'utils/useCustomLocation';
import { currencyOf, isEmpty, isLayoutXs, roundHalfToEven, roundToTwoDecimalPlaces, toFixed, VALOR_MONETARIO_MAXIMO } from 'utils/util';
import "./footer.css";

type Props = {
    onClickAvancar: () => void;
    onClickCancelar: () => void;
    onSwitchOptions?: () => void;
    troca?: {
        isVisible: boolean;
    };
    isDialogVisible?: boolean;
    floatingActionsProps?: FloatingActionsProps;
    brinde?: boolean;
    onClickBrinde?: () => void;
    showModalTroco?: () => void;
};

const initialState = {
    showModalDescontoAcrescimoItem: false,
    showModalDescontoAcrescimoNaoAutorizado: false,
    descontoAcrescimoType: null as TipoDescontoAcrescimoAutorizador | null,
    showLoading: false,
    showToolTipTroca: false,
};

type ButtonScreenVariables = {
    id: string;
    icon: string;
    label: string;
    disable?: () => boolean;
    onClick?: () => void;
};

type ScreenVariables = {
    btnRed: ButtonScreenVariables;
    btnGreen: ButtonScreenVariables;
    labelTotalPagar: string;
};

type ScreenVariablesMap = {
    [path: string]: ScreenVariables;
};

const initialStatePreVenda: PreVendaState & { show: boolean; } = {
    show: false,
    numero: "",
    cliente: "",
    vendedor: "",
    emissao: "",
    observacao: '',
    valorTotalLiquido: 0,
    valorTotalBruto: 0,
    valorAcrescimo: 0,
};

const Footer = (props: Props) => {
    const { addError, closeSnack, addSuccess } = useSnackbarCustom();
    const { throwErrorMessage } = useCatchApiError();
    const state = useAppSelector(s => s.state);
    const pagamento = useAppSelector(s => s.pagamento);
    const valePresente = useAppSelector(s => s.valePresente);
    const { faltaReceber, tableRows, troco } = pagamento;
    const configuracaoDescontoUsuario = useAppSelector(e => e.configuracoes.configuracaoDesconto);
    const [openStateDadosFreteDialog, setOpenStateDadosFreteDialog] = useState(false);
    const [openStateTrocaReferenciadaDialog, setOpenStateTrocaReferenciadaDialog] = useState(false);
    const location = useLocation();
    const [randomUuid] = useGenerateUuid();
    const totalPedidoRef = useRef<HTMLInputElement>(null);
    const pagamentoService = PagamentoService();
    const registraVendaService = RegistraVendaService();
    const {
        isTelaRegistraVenda,
        isTelaPagamento,
        isTelaValePresente,
        isTelaPreVenda,
    } = useCustomLocation();
    const { venda: vendaRolesFooter, preVenda: preVendaRolesFooter } = useFlowRoles();
    const { canFinalizar } = vendaRolesFooter.pagamento;
    const isEditingPedido = !!useAppSelector(e => e.state.pedido.numero);
    const isPreVenda = isTelaPreVenda();
    const pickByFluxo = <T,>(preNovo: T, preEditar: T, vendaNovo: T, vendaEditar: T): T => {
        if (isPreVenda) return isEditingPedido ? preEditar : preNovo;
        return isEditingPedido ? vendaEditar : vendaNovo;
    };
    const canDadosFrete = !isPreVenda && (isEditingPedido ? vendaRolesFooter.canDadosFrete : vendaRolesFooter.canNovoDadosFrete);
    const canDescontoRodape = pickByFluxo(preVendaRolesFooter.canNovoDescontoRodape, preVendaRolesFooter.canDescontoRodape, vendaRolesFooter.canNovoDescontoRodape, vendaRolesFooter.canDescontoRodape);
    const descontoRodapeEditavel = !isTelaPagamento() && canDescontoRodape;
    const canAcrescimo = pickByFluxo(preVendaRolesFooter.canNovoAcrescimo, preVendaRolesFooter.canAcrescimo, vendaRolesFooter.canNovoAcrescimo, vendaRolesFooter.canAcrescimo);
    const canFinalizarPreVenda = isEditingPedido ? preVendaRolesFooter.canFinalizar : preVendaRolesFooter.canNovoFinalizar;
    const {
        quantidadeTotal,
        quantidadeTotalTroca,
        valorTotalLiquidoTroca,
        valorTotalBruto,
        valorTotalLiquido,
        itensTroca,
        itens,
    } = state.pedido;
    const {
        tipoDesconto,
        valorDesconto,
        percentualDesconto,
        acrescimo,
    } = state.pedido.pedidoDescontoAcrescimo;
    const { descontoMaximoPedido, acrescimoMaximoPedido, uuid: userConfiguracaoDescontoUUID } = useAppSelector(e => e.configuracoes.configuracaoDesconto);
    const {
        descontoMaximoPedido: descontoMaximoPedidoAutorizador,
        descontoMaximoItem: descontoMaximoItemAutorizador,
        acrescimoMaximoPedido: acrescimoMaximoPedidoAutorizador,
        uuid: uuidAutorizador
    } = useAppSelector(e => e.configuracoes.configuracaoDescontoAutorizador.configuracaoDesconto);
    const configuracaoDescontoService = ConfiguracaoDescontoAcrescimoService();
    const tempDescontoMaximoPedido = useRef<number>(0);
    const valorSolicitadoRef = useRef<number | null>(null);
    const token = useAppSelector(e => e.token);
    const loginService = LoginService();
    const estabelecimento = useAppSelector(e => e.estabelecimentoSelecionado);
    const [stateLocal, setStateLocal] = useState(initialState);
    const { pedido } = useAppSelector(e => e.state);
    const [stateLocalPreVenda, setStateLocalPreVenda] = useState(initialStatePreVenda);
    const finalizarPreVendaRef = useRef<boolean>(false);

    const getShowTrocoFooter = () => {
        if (!troco) return true;
        if (troco && !troco.tipoTrocoPagar) return false;
        return true;
    };

    const valorTotalBrindes = useMemo(() => {
        return itens.filter(e => e.brinde).reduce((prev, act) => prev + act.valorTotal, 0);
    }, [itens]);

    const valorTotalVenda = roundToTwoDecimalPlaces(
        roundHalfToEven(valorTotalLiquido - valorTotalBrindes - valorTotalLiquidoTroca, 2)
    );

    const configuracaoBalcao = useAppSelector(e => e.configuracoes.configuracaoPedidoBalcao);
    const caixa = useAppSelector(s => s.caixa);

    const isCaixaObrigaVendedor = useCallback((): boolean => {
        return configuracaoBalcao.caixasObrigaVendedor?.some(s => s.uuid === caixa.caixaAtual.caixa?.uuid) ?? false;
    }, [configuracaoBalcao.caixasObrigaVendedor, caixa]);

    useEffect(() => {
        if (isTelaRegistraVenda()) {
            dispatch(setvalorDescontoPagamento({ valorDesconto, valorTotalBruto }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valorDesconto, valorTotalLiquido]);

    useEffect(() => {
        if (isTelaRegistraVenda()) {
            dispatch(setvalorDescontoPagamento({ valorDesconto: 0, valorTotalBruto: valePresente.valePresente?.valor ?? 0 }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valePresente.valePresente?.valor]);

    useEffect(() => {
        if (state.pedido.itens.length > 0 && state.pedido.itensTroca.length > 0) {
            const qtdItens = state.pedido.itens.map(e => e.quantidade).reduce((prev, value) => prev + value, 0);
            const qtdItensTroca = state.pedido.itensTroca.map(e => e.quantidade).reduce((prev, value) => prev + value, 0);
            const valorTotalItens = state.pedido.itens.map(e => e.valorTotal).reduce((prev, value) => prev + value, 0);
            const valorTotalItensTroca = state.pedido.itensTroca.map(e => e.valorTotal).reduce((prev, value) => prev + value, 0);

            if ((qtdItens === qtdItensTroca) && (valorTotalItens === valorTotalItensTroca)) {
                dispatch(resetDescontoFooter());
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.pedido.itens, state.pedido.itensTroca]);

    useEffect(() => {
        window.addEventListener('keydown', (e) => {
            switch (e.key) {
                case 'F9':
                    e.preventDefault();
                    totalPedidoRef.current && totalPedidoRef.current.focus();
                    break;
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        if (faltaReceber < 0 && !tableRows.length) {
            addError({ id: 'erro-faltarecebermenorquevenda', message: 'Valor das formas de pagamento não pode ser maior que o total da venda', persist: false });
        } else {
            closeSnack('erro-faltarecebermenorquevenda');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [faltaReceber]);

    const isTrocaVisible = () => {
        return props.troca?.isVisible ?? false;
        //eslint-disable-next-line
    };

    const dispatch = useAppDispatch();

    const toggleTipoDescontoFooter = () => {
        dispatch(toogleTipoDescontFooter());
    };

    const saveTempDesconto = useCallback((prevDesconto: number, uuid: string) => {
        tempDescontoMaximoPedido.current = prevDesconto;
    }, []);

    const onBlurDescontoPedido = (value: number) => {
        if (configuracaoDescontoUsuario.uuid === null) return;

        valorSolicitadoRef.current = value;
        if (value <= descontoMaximoPedido) {
            dispatch(addPedidoDescontoAcrescimo({
                itemDesconto: {
                    uuidAutorizador: userConfiguracaoDescontoUUID,
                    percentualDesconto: valorSolicitadoRef.current,
                    tipoDesconto: tipoDesconto,
                    valorDesconto: valorDesconto,
                    acrescimo: acrescimo,
                }
            }));
        }
        if (descontoMaximoPedidoAutorizador && value <= descontoMaximoPedidoAutorizador) {
            return dispatch(addPedidoDescontoAcrescimo({
                itemDesconto: {
                    uuidAutorizador: uuidAutorizador,
                    percentualDesconto: valorSolicitadoRef.current,
                    tipoDesconto: tipoDesconto,
                    valorDesconto: valorDesconto,
                    acrescimo: acrescimo,
                }
            }));
        }
        if (value <= tempDescontoMaximoPedido.current) return tempDescontoMaximoPedido.current = 0;

        if (value > descontoMaximoPedido) {
            configuracaoDescontoService.validaDescontoSolicitado(value, TipoDescontoAcrescimoAutorizador.DESCONTO_PEDIDO)
                .then(({ data }: { data: boolean; }) => {
                    const possuiData = !!data;
                    setStateLocal(prev => ({
                        ...prev,
                        showModalDescontoAcrescimoItem: possuiData,
                        showModalDescontoAcrescimoNaoAutorizado: !possuiData,
                        descontoAcrescimoType: TipoDescontoAcrescimoAutorizador.DESCONTO_PEDIDO
                    }));
                })
                .catch(() => { });
        }
    };

    const acrescimoLocal = useRef(acrescimo);

    useEffect(() => {
        acrescimoLocal.current = acrescimo;
    }, [acrescimo]);

    const onBlurAcrescimo = () => {
        if (configuracaoDescontoUsuario.uuid === null) {
            return dispatch(setAcrescimo(acrescimoLocal.current));
        };

        valorSolicitadoRef.current = acrescimoLocal.current;

        if (acrescimoLocal.current > acrescimoMaximoPedido) {
            configuracaoDescontoService.validaDescontoSolicitado(acrescimoLocal.current, TipoDescontoAcrescimoAutorizador.ACRESCIMO_PEDIDO)
                .then(({ data }: { data: boolean; }) => {
                    const possuiData = !!data;
                    setStateLocal(prev => ({
                        ...prev,
                        showModalDescontoAcrescimoItem: possuiData,
                        showModalDescontoAcrescimoNaoAutorizado: !possuiData,
                        descontoAcrescimoType: TipoDescontoAcrescimoAutorizador.ACRESCIMO_PEDIDO
                    }));
                })
                .catch(() => { });
        } else {
            dispatch(setAcrescimo(acrescimoLocal.current));
        }
    };

    const onChangeDescontoFooter = useCallback((value: number = 0) => {
        dispatch(setDescontoFooter({ value }));
        dispatch(setvalorDescontoPagamento({ valorDesconto: value, valorTotalBruto }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeValorLiquido = useCallback((value: number = 0, sourceEvent: SourceType) => {
        if (!isTelaValePresente()) {
            dispatch(setValorLiquido({ value, sourceEvent }));
        }
        if (sourceEvent === "event") {
            dispatch(changeTotalLiquido(value));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onFocusTotalizador = () => {
        tempDescontoMaximoPedido.current = percentualDesconto;
        if (valorTotalLiquido === 0) return totalPedidoRef.current?.setSelectionRange(4, 4);
    };

    const onBlurTotalizador = () => {
        onBlurDescontoPedido(percentualDesconto);
    };

    const handleAutorizaDesconto = (username: string, password: string, switchBoolean: boolean) => {
        closeSnack('same-user-exception');
        closeSnack('desconto-aplicado-com-sucesso');
        closeSnack('usuario_senha_invalido');
        if (username === token.USER_INFO?.username) {
            return addError({ id: "same-user-exception", message: "Seu usuário não permite este desconto, solicite à um responsável", closeable: true, persist: false });
        }

        setStateLocal(prevState => ({ ...prevState, showLoading: true }));
        let tokenAutorizador = "";
        loginService.loga({ user: username, password: password })
            .then(({ data }: { data: IToken; }) => {
                tokenAutorizador = data.access_token!;
                return configuracaoDescontoService.getConfiguracaoDescontoAutorizador(tokenAutorizador, estabelecimento.uuid);
            })
            .then(({ data }: { data: ConfiguracaoDescontoTO; }) => {
                const valorSolicitado = valorSolicitadoRef.current;
                let acrescimoMaximoPedidoToSet = acrescimoMaximoPedidoAutorizador;
                let descontoMaximoPedidoToSet = descontoMaximoPedidoAutorizador;

                if (stateLocal.descontoAcrescimoType === TipoDescontoAcrescimoAutorizador.ACRESCIMO_PEDIDO) {
                    dispatch(addPedidoDescontoAcrescimo({
                        itemDesconto: {
                            uuidAutorizador: data.uuid,
                            percentualDesconto: percentualDesconto,
                            tipoDesconto: tipoDesconto,
                            valorDesconto: valorDesconto,
                            acrescimo: acrescimoLocal.current
                        }
                    }));
                    acrescimoMaximoPedidoToSet = valorSolicitado ?? acrescimoMaximoPedidoToSet;
                } else {
                    dispatch(addPedidoDescontoAcrescimo({
                        itemDesconto: {
                            uuidAutorizador: data.uuid,
                            percentualDesconto: valorSolicitado!,
                            tipoDesconto: tipoDesconto,
                            valorDesconto: valorDesconto,
                            acrescimo: acrescimo
                        }
                    }));
                    descontoMaximoPedidoToSet = valorSolicitado ?? descontoMaximoPedidoToSet;
                }
                dispatch(setConfiguracaoDescontoAutorizador({
                    token: tokenAutorizador,
                    configuracaoDesconto: {
                        uuid: data.uuid,
                        usuario: data.usuario,
                        descontoMaximoItem: descontoMaximoItemAutorizador ?? data.descontoMaximoItem,
                        descontoMaximoPedido: descontoMaximoPedidoToSet,
                        acrescimoMaximoPedido: acrescimoMaximoPedidoToSet,
                        autorizaDesconto: data.autorizaDesconto,
                    }
                }));
                setStateLocal(prevState => ({ ...prevState, showLoading: false, showModalDescontoAcrescimoItem: false, descontoAcrescimoType: null }));
                addSuccess({ id: "desconto-aplicado-com-sucesso", message: "Desconto aplicado", closeable: true, persist: false, hideDuration: 2000 });
            })
            .catch((err) => {
                if (err.response.data.description === "SemConfiguracaoDesconto") {
                    throwErrorMessage(err);
                } else {
                    addError({ id: "usuario_senha_invalido", message: "Usuário ou senha inválidos", closeable: true, persist: false });
                }
                setStateLocal(prevState => ({ ...prevState, showLoading: false }));
            });
        //eslint-disable-next-line;
    };

    const getTotalValue = () => {
        if (!isTelaValePresente()) {
            return roundToTwoDecimalPlaces(
                roundHalfToEven(valorTotalLiquido - valorTotalBrindes - valorTotalLiquidoTroca, 2)
            );
        }
        return roundHalfToEven((valePresente.valePresente?.valor ?? 0) - faltaReceber, 2);
    };

    const closeAutorizaDesconto = useCallback(() => {
        if (stateLocal.descontoAcrescimoType === TipoDescontoAcrescimoAutorizador.ACRESCIMO_PEDIDO) {
            acrescimoLocal.current = 0;
            dispatch(resetAcrescimoFooter());
        } else {
            dispatch(resetDescontoFooter());
        }
        setStateLocal(prevState => ({ ...prevState, showModalDescontoAcrescimoNaoAutorizado: false, showModalDescontoAcrescimoItem: false, descontoAcrescimoType: null }));
        //eslint-disable-next-line
    }, [stateLocal.descontoAcrescimoType]);

    const getSemNotaReferenciada = () => {
        return !!state.clientePossuiEnderecoForaEstado && !!state.pedido.itensTroca.length && !state.pedido.itensTroca.some(s => !!s.notaReferenciadaInfo?.notas.length);
    };

    const screenVariables: ScreenVariablesMap = {
        'registra-venda': {
            btnRed: {
                id: 'cancelar-btn',
                icon: 'fa-xmark',
                label: 'Cancelar',
            },
            btnGreen: {
                id: 'avancar-btn',
                icon: 'fa-money-bill-1-wave',
                label: 'Avançar',
            },
            labelTotalPagar: 'Total à pagar (F9)'
        },
        'pre-venda': {
            btnRed: {
                id: 'cancelar-btn',
                icon: 'fa-xmark',
                label: 'Cancelar',
            },
            btnGreen: {
                id: 'avancar-btn',
                icon: 'fa-money-bill-1-wave',
                label: 'Finalizar pré-venda',
                disable: () => !canFinalizarPreVenda,
                onClick: () => {
                    onFinalizarPreVenda();
                }
            },
            labelTotalPagar: 'Total à pagar (F9)'
        },
        'pagamento': {
            btnRed: {
                id: 'voltar-btn',
                icon: 'fa-arrow-left',
                label: 'Voltar',
            },
            btnGreen: {
                id: 'finalizar-btn',
                icon: 'fa-handshake',
                label: isLayoutXs() ? 'Finalizar' : 'Finalizar Venda',
                disable: () => !canFinalizar || (isTelaPagamento() && getSemNotaReferenciada()),
            },
            labelTotalPagar: 'Total à pagar'
        },
        'vale-presente': {
            btnRed: {
                id: 'cancelar-btn',
                icon: 'fa-xmark',
                label: 'Cancelar',
            },
            btnGreen: {
                id: 'confirmar-btn',
                icon: 'fa-thumbs-up',
                label: 'Confirmar',
            },
            labelTotalPagar: 'Total pago'
        },
    };

    const getScreenVariables = (): ScreenVariables => {
        return (screenVariables as any)[location.pathname.replace('/', '')];
    };

    const resetAll = useCallback(() => {
        dispatch(resetDesconto());
        dispatch(resetState());
        dispatch(resetRows());
        dispatch(resetPagamento());
        dispatch(resetChavesReferenciadas());
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (isTelaPreVenda() && finalizarPreVendaRef.current) {
            finalizarPreVendaRef.current = false;
            dispatch(changeLinearFinalizaVenda({ progress: 50 }));
            setTimeout(() => {
                registraVendaService.salvarVenda(true)
                    .then(({ data }) => {
                        dispatch(changeLinearFinalizaVenda({ progress: 100 }));
                        setStateLocalPreVenda(prevState => ({
                            ...prevState,
                            show: true,
                            cliente: data.cliente?.descritivo?.split(" - ")[1] ?? "CONSUMIDOR",
                            numero: data.numero,
                            vendedor: data.vendedorPrincipal?.descritivo?.split(" - ")[1] ?? "",
                            emissao: data.emissao,
                            observacao: data.observacao,
                            valorTotalLiquido: data.valorTotalLiquido,
                            valorTotalBruto: data.valorTotalBruto,
                            valorAcrescimo: data.pedidoDescontoAcrescimo.acrescimo,
                        }));
                    }).catch(() => {
                        addError({
                            message: 'Ocorreu um erro inesperado. Se o erro persistir, entre em contato com o suporte',
                            persist: true,
                            severity: 'error',
                            preventDuplicate: false,
                            closeable: true,
                        });
                    }).finally(() => {
                        setTimeout(() => {
                            dispatch(loadingWithOpt({
                                loading: false,
                                tipo: Tipo.CIRCULAR,
                                message: "Salvando pedido",
                                progress: 0,
                            }));
                            resetAll();
                        }, 1000);
                    });
            }, 500);
        }
        //eslint-disable-next-line
    }, [tableRows]);

    const onFinalizarPreVenda = () => {
        if (state.verificandoAlertaPoliticaVenda) {
            return addError({ id: 'erro-verificando-politica-venda-pre-venda', message: 'Aguarde a validação do cliente selecionado.', closeable: true, preventDuplicate: true });
        }
        if (state.bloqueiaVendaContaReceberVencida) {
            return addError({ id: 'erro-bloqueio-conta-receber-vencida-pre-venda', message: 'Cliente possui contas a receber vencidas.', closeable: true, preventDuplicate: true });
        }
        if (state.bloqueiaVendaConsignadoEmAndamento) {
            return addError({ id: 'erro-bloqueio-consignado-em-andamento-pre-venda', message: 'Cliente possui consignado em andamento.', closeable: true, preventDuplicate: true });
        }
        if (!pedido.itens.length) {
            return addError({ id: 'erro-semproduto-pre-venda', message: 'Selecione ao menos um produto para continuar', closeable: true, preventDuplicate: true });
        }
        if (isCaixaObrigaVendedor() && !pedido.vendedorPrincipal) {
            return addError({ id: 'erro-vendedor-obrigatorio-pre-venda', message: 'Para este caixa, vendedor é obrigatório', closeable: true, preventDuplicate: true });
        }
        if (!pedido.vendedorPrincipal && !!pedido.outrosVendedores.length) {
            return addError({ id: 'erro-possui-guias-sem-vendedor-principal', message: 'Selecione um vendedor ou remova os outros vendedores', closeable: true, preventDuplicate: true });
        }
        dispatch(loadingWithOpt({
            loading: true,
            tipo: Tipo.LINEAR,
            message: "Salvando pedido",
            progress: 0,
        }));
        pagamentoService.getFormasPagamento().then(({ data }) => {
            dispatch(addRow({
                name: 'OUTROS',
                descritivoFormaPagamento: 'Outros',
                formaPagamento: {
                    descritivo: 'OUTROS DEVOLUÇÃO',
                    uuid: getFormaPagamentoAbstracModel('OUTROS', data).uuid,
                },
                infoAdicional: {
                    descritivo: 'VENDA',
                    numeroParcelas: 1,
                    tipo: TipoInformacaoAdicional.OUTROS,
                },
                valor: valorTotalLiquido,
                editavel: true,
                pago: true,
                numeroDeDias: null,
                vencimento: null
            }));
            finalizarPreVendaRef.current = true;
        }).catch(() => {
            addError({
                message: 'Ocorreu um erro inesperado. Se o erro persistir, entre em contato com o suporte',
                persist: true,
                severity: 'error',
                preventDuplicate: false,
                closeable: true,
            });
        });
    };

    const handleApplyAnimationBtn = (troca: boolean, animation: 'shrink' | 'grow', duration: number) => {
        const map = {
            vale: 'vale-presente-btn',
            troca: 'troca-referenciada-btn',
        };
        const button = document.getElementById(map[troca ? 'troca' : 'vale']);
        button?.classList.add(animation);
        setTimeout(() => {
            button?.classList.remove(animation);
        }, duration);
    };

    const onSwitchOptions = () => {
        const troca = isTrocaVisible();
        const duration = 250;

        handleApplyAnimationBtn(troca, 'shrink', duration);
        setTimeout(() => {
            props.onSwitchOptions?.();
            setTimeout(() => {
                handleApplyAnimationBtn(!troca, 'grow', duration);
            },);
        }, duration);
    };

    return (
        <>
            <Box
                sx={{
                    gridColumn: '1 / -1'
                }}
            >
                <Grid container spacing={2} sx={{ textAlign: "center" }}>

                    {(isTelaRegistraVenda() || isTelaPreVenda()) &&
                        <Grid id="footer_totalizador_grid" item={true} xs={12} sm={6} md={itensTroca.length > 0 ? 2.4 : 3} lg={itensTroca.length > 0 ? 2.4 : 3}>
                        {/* <Grid id="footer_totalizador_grid" item={true} xs={12} sm={6} md={itensTroca.length > 0 ? 3 : 4} lg={itensTroca.length > 0 ? 3 : 4}> */}
                            <CardTotalizador
                                id='quantidade'
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '50%' }}>
                                    <CardTotalizadorLabel
                                        id='titulo_totalizador'
                                        label='Quantidade da venda:'
                                    />
                                    <CardTotalizadorValue
                                        id='titulo_totalizador'
                                        value={quantidadeTotal}
                                    />
                                </Box>

                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '50%' }}>
                                    <CardTotalizadorLabel
                                        id='titulo_totalizador'
                                        label='Total da venda:'
                                    />
                                    <CardTotalizadorValue
                                        id='titulo_totalizador'
                                        value={currencyOf(valorTotalBruto - valorTotalBrindes)}
                                    />
                                </Box>
                            </CardTotalizador>
                        </Grid>
                    }

                    {(isTelaPagamento() || isTelaValePresente()) && getShowTrocoFooter() &&
                        <Grid item={true} xs={12} sm={6} md={itensTroca.length > 0 ? 2.4 : 3} lg={itensTroca.length > 0 ? 2.4 : 3}>
                        {/* <Grid item={true} xs={12} sm={6} md={itensTroca.length > 0 ? 3 : 4} lg={itensTroca.length > 0 ? 3 : 4}> */}
                            <CardTotalizador
                                id='totalizador-falta-receber'
                            >
                                <CardTotalizadorValue
                                    id="valor_tolalizador_falta_receber"
                                    value={currencyOf(faltaReceber === 0 ? 0 : faltaReceber)}
                                    color={faltaReceber > 0 ? customColors.roxoDasNotas : faltaReceber === 0 ? theme.palette.primary.main : 'var(--error)'}
                                />

                                <CardTotalizadorLabel
                                    id="footer_falta_receber"
                                    label='Falta à receber'
                                />
                            </CardTotalizador>
                        </Grid>}

                    {(isTelaPagamento() || isTelaValePresente()) && troco?.valor && !troco?.tipoTrocoPagar &&
                        <Grid item={true} xs={12} sm={6} md={itensTroca.length > 0 ? 3 : 4} lg={itensTroca.length > 0 ? 3 : 4}
                            sx={{ cursor: 'pointer' }}
                            onClick={props.showModalTroco}>
                            <CardTotalizador
                                id='troco'
                            >
                                <CardTotalizadorValue
                                    id="valor_tolalizador_troco"
                                    value={currencyOf(troco.valor)}
                                    color={'var(--error)'}
                                />

                                <CardTotalizadorLabel
                                    id="valor_tolalizador_troco"
                                    label='Troco à devolver'
                                />
                            </CardTotalizador>
                        </Grid>}

                    {!isTelaValePresente() &&
                        <Grid item={true} xs={12} sm={6} md={itensTroca.length > 0 ? 2.4 : 3} lg={itensTroca.length > 0 ? 2.4 : 3}>
                        {/* <Grid item={true} xs={12} sm={6} md={itensTroca.length > 0 ? 3 : 4} lg={itensTroca.length > 0 ? 3 : 4}> */}
                            <CardTotalizador
                                id='desconto'
                            >
                                <CardTotalizadorValue id="footer_desconto_titulo">
                                    <DescontoInput
                                        isVisualizar={isTelaPagamento() || !canDescontoRodape}
                                        hotKey='F8'
                                        onBlur={onBlurDescontoPedido.bind(null, percentualDesconto)}
                                        onSaveTempDesconto={saveTempDesconto}
                                        style={{ width: '13rem', height: '1.4rem' }}
                                        item={{
                                            tipoDesconto,
                                            valorDesconto,
                                            percentualDesconto,
                                            valorTotalBruto,
                                            onChangeDesconto: onChangeDescontoFooter,
                                            uuid: randomUuid()
                                        }}
                                        inputProps={{ 'data-testid': 'footer-desconto-input', style: { textAlign: 'center', fontSize: '24px', color: descontoRodapeEditavel ? theme.palette.primary.main : theme.palette.text.disabled, fontWeight: 700, fontFamily: 'Work Sans, sans-serif' } }}
                                        iconButtonProps={{
                                            disabled: (percentualDesconto === 0 && valorDesconto === 0) && valorTotalVenda <= 0,
                                            onToggleTipoDesconto: toggleTipoDescontoFooter,
                                            percentoProps: {
                                                color: descontoRodapeEditavel ? theme.palette.primary.main : theme.palette.text.disabled,
                                            },
                                            valorProps: {
                                                color: descontoRodapeEditavel ? theme.palette.primary.main : theme.palette.text.disabled,
                                            }
                                        }}
                                        origem='FOOTER'
                                    />

                                </CardTotalizadorValue>

                                <CardTotalizadorLabel
                                    id="footer_desconto_titulo"
                                    label="Desconto (F8)"
                                    disabled={!canDescontoRodape}
                                />
                            </CardTotalizador>
                        </Grid>
                    }

                    {!isTelaValePresente() &&
                        <Grid id="footer_acrescimo" item={true} xs={12} sm={itensTroca.length > 0 ? 6 : 12} md={itensTroca.length > 0 ? 2.4 : 3} lg={itensTroca.length > 0 ? 2.4 : 3} >
                            <CardTotalizador
                                id='acrescimo'
                            >
                                <CardTotalizadorValue id="acrescimo">
                                    <NumericFormat
                                        id="footer_acrescimo_input"
                                        disabled={quantidadeTotal === 0 || isTelaPagamento() || !canAcrescimo}
                                        onBlur={() => onBlurAcrescimo()}
                                        style={{ height: '1.4rem', width: '13rem' }}
                                        decimalScale={2}
                                        fixedDecimalScale
                                        defaultValue={0}
                                        allowedDecimalSeparators={[',']}
                                        customInput={TextField}
                                        decimalSeparator=","
                                        prefix={'R$ '}
                                        thousandsGroupStyle="thousand"
                                        thousandSeparator="."
                                        variant="standard"
                                        inputProps={{ 'data-testid': 'footer-acrescimo-input', style: { textAlign: 'center', fontSize: '24px', color: theme.palette.primary.main, fontWeight: 700, fontFamily: 'Work Sans, sans-serif' } }}
                                        value={acrescimoLocal.current}
                                        allowNegative={false}
                                        isAllowed={({ floatValue }) => !floatValue || floatValue <= VALOR_MONETARIO_MAXIMO}
                                        onValueChange={({ floatValue }) => acrescimoLocal.current = floatValue ?? 0}
                                        InputProps={{
                                            endAdornment: (
                                                <span>
                                                    <IconButton disabled>
                                                        <i className="fa-solid fa-money-bill-1-wave" style={{ color: theme.palette.text.disabled }} />
                                                    </IconButton>
                                                </span>
                                            )
                                        }}
                                    />
                                </CardTotalizadorValue>

                                <CardTotalizadorLabel
                                    id="acrescimo"
                                    label='Acréscimo'
                                    color={tableRows.length > 0 ? theme.palette.text.disabled : ''}
                                />
                            </CardTotalizador>
                        </Grid >
                    }

                    {isTelaValePresente() &&
                        <Grid item={true} xs={12} sm={6} md={4} lg={4}>
                            <CardTotalizador
                                id='vale-presente'
                            >
                                <CardTotalizadorValue
                                    id="valor-total-vale-presente"
                                    value={currencyOf(valePresente.valePresente?.valor ?? 0)}
                                    color={theme.palette.primary.main}
                                />

                                <CardTotalizadorLabel
                                    id="footer-valor-total-vale-presente"
                                    label='Vale presente'
                                />
                            </CardTotalizador>
                        </Grid>}

                    {itensTroca.length > 0 && <Grid id="footer_desconto_grid" item={true} xs={12} sm={6} md={2.4} lg={2.4}>
                    {/* {itensTroca.length > 0 && <Grid id="footer_desconto_grid" item={true} xs={12} sm={6} md={3} lg={3}> */}
                        <CardTotalizador
                            id='troca'
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '50%' }}>
                                <CardTotalizadorLabel
                                    id='quantidade-troca'
                                    label='Quantidade da troca:'
                                />
                                <CardTotalizadorValue
                                    id='quantidade-troca'
                                    value={quantidadeTotalTroca}
                                    color={customColors.roxoDasNotas}
                                />
                            </Box>

                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '50%' }}>
                                <CardTotalizadorLabel
                                    id='valor-troca'
                                    label='Total da troca:'
                                />
                                <CardTotalizadorValue
                                    id='valor-troca'
                                    value={currencyOf(valorTotalLiquidoTroca)}
                                    color={customColors.roxoDasNotas}
                                />
                            </Box>
                        </CardTotalizador>
                    </Grid>}

                    <Grid id="footer_total_grid" item={true} xs={12} sm={itensTroca.length > 0 ? 6 : 12} md={itensTroca.length > 0 ? 2.4 : 3} lg={itensTroca.length > 0 ? 2.4 : 3} >
                    {/* <Grid id="footer_total_grid" item={true} xs={12} sm={itensTroca.length > 0 ? 6 : 12} md={itensTroca.length > 0 ? 3: 4} lg={itensTroca.length > 0 ? 3 : 4} > */}
                        <CardTotalizador
                            id='total-pagar'
                        >
                            <CardTotalizadorValue id="total-pagar">
                                <NumericFormat
                                    id="footer_total_input"
                                    onFocus={onFocusTotalizador}
                                    onBlur={onBlurTotalizador}
                                    disabled={getTotalValue() <= 0 || isTelaPagamento() || isTelaValePresente() || !canDescontoRodape}
                                    style={{ height: '1.4rem', width: '13rem' }}
                                    decimalScale={2}
                                    inputRef={totalPedidoRef}
                                    fixedDecimalScale
                                    defaultValue={0}
                                    allowedDecimalSeparators={[',']}
                                    customInput={TextField}
                                    decimalSeparator=","
                                    prefix={'R$ '}
                                    thousandsGroupStyle="thousand"
                                    thousandSeparator="."
                                    variant="standard"
                                    inputProps={{ 'data-testid': 'footer-total-input', style: { textAlign: 'center', fontSize: '24px', color: theme.palette.primary.main, fontWeight: 700, fontFamily: 'Work Sans, sans-serif' } }}
                                    value={getTotalValue()}
                                    isAllowed={({ floatValue }) => {
                                        if (!floatValue) { return true; }
                                        if (floatValue > 0) { return floatValue <= toFixed(valorTotalBruto - valorTotalLiquidoTroca); }
                                        return false;
                                    }}
                                    allowNegative={true}
                                    onValueChange={({ floatValue }, { source }) => onChangeValorLiquido(floatValue, source)}
                                />
                            </CardTotalizadorValue>

                            <CardTotalizadorLabel
                                id="total-pagar"
                                label={getScreenVariables().labelTotalPagar}
                                disabled={!canDescontoRodape}
                            />
                        </CardTotalizador>
                    </Grid >
                </Grid >
            </Box >

            <Box
                sx={{
                    gridColumn: '1 / -1',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <CustomButton id={getScreenVariables().btnRed.id}
                    disabled={(!quantidadeTotal && !itens.every(e => e.brinde)) && !isTelaValePresente()}
                    onClick={props.onClickCancelar}
                    variant="contained"
                    color="error"
                    startIcon={
                        <Icon
                            className={`fa-solid ${getScreenVariables().btnRed.icon}`}
                        />}
                >
                    {getScreenVariables().btnRed.label}
                </CustomButton>

                <Box sx={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    maxHeight: '50px',
                    position: 'relative',
                    gap: '10px'
                }}>
                    {props.brinde &&
                        <CustomButton
                            id='brinde-btn'
                            variant="contained"
                            sx={{
                                color: theme.palette.background.default,
                                backgroundColor: theme.palette.primary.main,
                                '&:hover': { backgroundColor: theme.palette.primary.main },
                            }}
                            startIcon={<Icon className='fa-solid fa-gifts' sx={{ width: '25px' }} />}
                            animated
                            containerStyle={{
                                boxShadow: "2px 2px 10px rgba(0,0,0,0.35)"
                            }}
                            onClick={props.onClickBrinde}
                        >
                            Brinde ativo
                        </CustomButton>
                    }

                    {!isTelaPreVenda() && [
                        <React.Fragment key="buttons-frete-troca-btns">
                            {
                                <Box key="dados-frete-btn" position={'relative'}>
                                    {(!isTelaPagamento() && !isTelaValePresente()) &&
                                        <CustomButton
                                            id='dados-frete-btn'
                                            onClick={() => setOpenStateDadosFreteDialog(true)}
                                            variant="contained"
                                            disabled={isEmpty(state.pedido.itens) || !canDadosFrete}
                                            color='secondary'
                                            sx={{
                                                color: theme.palette.background.default,
                                            }}
                                            startIcon={<Icon className='fa-solid fa-truck' sx={{ width: '1.7rem' }} />}
                                        >
                                            Dados do frete
                                        </CustomButton>
                                    }
                                </Box>
                            }
                            {isTrocaVisible() && <Box key="troca-referenciada-btn" position={'relative'}>
                                {(!isTelaPagamento()) &&
                                    <CustomButton
                                        id='troca-referenciada-btn'
                                        onClick={() => setOpenStateTrocaReferenciadaDialog(true)}
                                        variant="contained"
                                        disabled={!state.pedido.cliente || !state.pedido.itensTroca.length}
                                        sx={{
                                            color: theme.palette.background.default,
                                            backgroundColor: customColors.roxoDasNotas,
                                            '&:hover': { backgroundColor: customColors.roxoDasNotas, filter: 'brightness(1.1)' },
                                            zIndex: 100
                                        }}
                                        startIcon={<Icon sx={{ width: '24px', marginLeft: '-1px' }} className='fa-solid fa-link' />}
                                    >
                                        Referenciar nota
                                    </CustomButton>
                                }
                            </Box>}
                        </React.Fragment>,

                        <Box key="troca-btn" position={'relative'} zIndex={isTrocaVisible() ? 100 : 1}>
                            {stateLocal.showToolTipTroca &&
                                <CustomToolTips
                                    id={`alt-escape-id`}
                                    position='absolute'
                                    bottom='50px'
                                    left='0'
                                    bgColor={theme.palette.grey[500]}
                                    color={theme.palette.background.default}
                                    height='30px'
                                    width={props.troca?.isVisible ? '130px' : '95px'}
                                    zIndex={100}
                                    display='flex'
                                    justifyContent='center'
                                    alignItems='center'
                                    borderRadius='10px'
                                    isVisible={isTrocaVisible()}
                                    trueText='ESC'
                                    falseText='ALT + T'
                                    autoCapitalize={true}
                                />
                            }
                            {(!isTelaPagamento() && !isTelaValePresente()) &&
                                <CustomButton
                                    onMouseEnter={() => { setStateLocal(prev => ({ ...prev, showToolTipTroca: true })); }}
                                    onMouseLeave={() => { setStateLocal(prev => ({ ...prev, showToolTipTroca: false })); }}
                                    id='troca-venda-btn'
                                    onClick={onSwitchOptions} variant="contained"
                                    sx={{
                                        color: theme.palette.background.default,
                                        backgroundColor: customColors.verdeClaroClaro,
                                        '&:hover': {
                                            backgroundColor: customColors.verdeClaroClaro,
                                            filter: 'brightness(.8)',
                                        },
                                    }}
                                    startIcon={<Icon className='fa-solid fa-retweet' />}
                                    animated={isTrocaVisible()}
                                >
                                    {isTrocaVisible() ? 'Confirmar' : 'Troca'}
                                </CustomButton>
                            }
                        </Box>
                    ]}
                    <CustomButton
                        disabled={getScreenVariables().btnGreen.disable?.()}
                        id={getScreenVariables().btnGreen.id}
                        onClick={getScreenVariables().btnGreen.onClick ?? props.onClickAvancar}
                        variant="contained"
                        color="success"
                        startIcon={
                            <Icon
                                className={`fa-solid ${getScreenVariables().btnGreen.icon}`}
                                sx={{ width: 'fit-content' }}
                            />
                        }>
                        {getScreenVariables().btnGreen.label}
                    </CustomButton>

                    {(props.floatingActionsProps) && <FloatingActions   {...props.floatingActionsProps} />}
                </Box>

                {stateLocal.showModalDescontoAcrescimoItem &&
                    <AutorizaDescontoAcrescimo
                        onClose={closeAutorizaDesconto}
                        valorSolicitado={valorSolicitadoRef}
                        onAutorizaDesconto={handleAutorizaDesconto}
                        tipoDescontoAcrescimoAutorizador={stateLocal.descontoAcrescimoType!}
                    />
                }
                {stateLocal.showLoading &&
                    <CustomLoading />
                }
                {stateLocal.showModalDescontoAcrescimoNaoAutorizado &&
                    <AutorizaDescontoItemError
                        valorSolicitado={valorSolicitadoRef}
                        closeModalDescontoItemError={closeAutorizaDesconto}
                        tipoDescontoAcrescimoAutorizador={stateLocal.descontoAcrescimoType!}
                    />
                }
                {stateLocalPreVenda.show &&
                    <PreVendaPdf
                        key="pre-venda-comprovante-footer"
                        {...stateLocalPreVenda}
                        onClose={() => setStateLocalPreVenda({ ...initialStatePreVenda })}
                    />
                }
            </Box >

            <DadosTransportador
                open={openStateDadosFreteDialog}
                setOpen={setOpenStateDadosFreteDialog}
                transportador={state.pedido.transportador}
                onConfirm={dados => dispatch(setTransportador(dados))}
                key="dados-transportador-footer"
            />

            <TrocaReferenciadaDialog
                open={openStateTrocaReferenciadaDialog}
                setOpen={setOpenStateTrocaReferenciadaDialog}
            />
        </>
    );

};

export default Footer;
